import { createUserOrgSettingsHooks } from "@/hooks/userOrgSettingsHooks";

/** A member's home page preferences for one org. */
export type UserHomeSettings = {
  migrate_banner_dismissed: boolean;
};

const hooks = createUserOrgSettingsHooks<UserHomeSettings>({
  resource: "user-home-settings",
  errorMessage: "Failed to dismiss the migration banner",
});

export const useUserHomeSettings = hooks.useSettings;
export const useUpdateUserHomeSettings = hooks.useUpdateSettings;
